import React, { Component, ReactNode } from 'react';
import { redirectToIdentityProvider } from 'utils/auth.util';
import { sendErrorToNewRelic } from 'utils/error.util';
import classes from './ErrorBoundary.module.css';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    // error
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    sendErrorToNewRelic(error, { type: 'Error boundary', errorInfo });

    console.error('Error boundary log:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={classes.errorContainer}>
          <div className={classes.center} data-testid="error-boundary">
            <h2>Oops, seems we have a problem.</h2>
            <p>
              If the problem persists,{' '}
              <button
                className={classes.inlineButton}
                type="button"
                onClick={redirectToIdentityProvider}
              >
                please click
              </button>{' '}
              here to refresh your session. If that doesn&rsquo;t work, please get in touch.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
